import { post } from 'lib/request'

export const signup = async (input: {
  email: string
  fullName: string
  password: string
}) => {
  return await post('api/auth/register', {
    body: input,
  })
}
